import React from "react";
import { Reveal } from "../shared/Reveal";

const CAPS = [
  ["Knowledge Before Investment", "See the evidence before you spend a penny."],
  ["Proof of Concept", "We prove the savings on-site before any roll-out."],
  ["Granular Monitoring", "Asset-level detail you have never seen before."],
  ["IoT + AI Intelligence", "Smart systems that improve decisions every day."],
  ["Central Intelligence Infrastructure", "All your sites on one platform — one source of truth."],
  ["Installed in 70+ Countries", "Proven worldwide — now available in the UK."],
];

export default function Why() {
  return (
    <section id="why-measure">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">WHY ENERGY VAULT</Reveal>
        <Reveal className="h2" tag="div">We Don't Assume. <span className="g">We Measure.</span></Reveal>
        <Reveal className="lead" tag="p">Backed by 30 years' experience and 20 years of R&amp;D — the intelligent platform infrastructure trusted across the globe.</Reveal>
        <div className="caps">
          {CAPS.map(([h, p], i) => (
            <Reveal className="cap" tag="div" key={h} style={{ transitionDelay: `${(i % 3) * 0.08}s` }} data-testid={`cap-${i}`}>
              <h3>{h}</h3><p>{p}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
